import {
  wdDetail,
  wdDetailEdit,
} from '@/api/prod/center'
import store from '@/store'

// 获取详情资料
export function getWdDetail(baseItemId) {
  return wdDetail({
    baseItemId
  }).then(res => {
    if (res.result === 1) {
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}
// 编辑详情
export function editWdDetail(data) {
  return wdDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
    if (r.skuList && r.skuList.length > 0) {
        r.skuList = r.skuList.map(item => {
            return isRequest ? {
            ...item,
            skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
            } : {
            ...item,
            skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
            }
        })
    }
    return isRequest ? {
        ...r,
        images: r.images ? JSON.stringify(r.images) : '',
        goodsDescImage: r.goodsDescImage ? JSON.stringify(r.goodsDescImage) : '',
        specifications: JSON.stringify(r.specifications ? r.specifications : []),
    } : {
        ...r,
        images: r.images ? JSON.parse(r.images) : [],
        specifications: r.specifications ? JSON.parse(r.specifications) : [],
        goodsDescImage: r.goodsDescImage ? JSON.parse(r.goodsDescImage) : [],
        deliveryTime: r.deliveryTime ? JSON.parse(r.deliveryTime) : null,
    }
}